import { Box } from '@mui/material'
import { EditButton } from '../EditButton'
import * as S from './styles'

interface IResponsibleCardProps {
  title: string
  relationName: string
  name: string
  handleEditResponsible?: () => void
  handleViewResponsible?: () => void
}

const ResponsibleCard = ({
  title,
  relationName,
  name,
  handleEditResponsible,
  handleViewResponsible,
}: IResponsibleCardProps) => {
  return (
    <S.Card elevation={3}>
      <S.ContentBox>
        <S.ContentInfo>
          <S.Responsible>{title}</S.Responsible>
          <S.Kinship>{relationName}</S.Kinship>
          <S.NameResponsible>{name}</S.NameResponsible>
        </S.ContentInfo>
        <S.ContentInfo>
          <EditButton onClick={handleEditResponsible} />
          <S.ViewContainer onClick={handleViewResponsible}>
            <S.View />
          </S.ViewContainer>
        </S.ContentInfo>
      </S.ContentBox>
    </S.Card>
  )
}

export { ResponsibleCard }
export type { IResponsibleCardProps }
